import { Pipe, PipeTransform, QueryList, TemplateRef } from '@angular/core';
import { PanelComponent } from '@widgets/site-common/panels/panel/panel.component';

@Pipe({
  name: 'panelTemplateRef'
})
export class PanelTemplatePipe implements PipeTransform {
  transform(panels: QueryList<PanelComponent>, index: number): TemplateRef<HTMLElement> | void {
    const list = panels.toArray();
    const listItem = list[index];
    if (!listItem) {
      return;
    }
    return listItem.templateContent;
  }
}
